import { makeStyles } from '@material-ui/core';
import { colors } from 'shared/themes';

export const ITEM_HEIGHT = 56;
export const ITEM_PADDING_TOP = 8;
export const SELECT_MODAL_WIDTH = 350;

const SELECT_WIDTH = 180;

export const useSelectStyles = makeStyles({
  root: {
    border: '0px solid #D1D5DA',
    borderRadius: '2px',
    color: colors.v2TextColor1,
    paddingBottom: '15px',
    paddingTop: '15px',
    '&$selected:hover': {
      backgroundColor: 'red',
    },
  },
  select: {
    minWidth: SELECT_WIDTH,
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    right: '10px',
  },
});

export const useOutlinedInputStyles = makeStyles({
  root: {
    fontSize: '13px',
    borderRadius: '2px',
    color: colors.primaryBlack,
    '&:hover $notchedOutline': {
      backgroundColor: 'transparent',
      borderColor: '#B6B6B6',
    },
    '&$focused $notchedOutline': {
      borderColor: '#7FB1F4',
      borderWidth: '1px',
    },
  },
  focused: {},
  notchedOutline: {},
});

export const useCheckboxStyles = makeStyles({
  root: {
    color: '#D0D3D9',
    '&$checked': {
      color: colors.primaryBlue,
      outlineColor: '#D0D3D9',
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  checked: {},
});

export const useListItemStyles = makeStyles({
  primary: {
    color: colors.v2TextColor2,
    fontSize: '13px',
    fontWeight: 'bold',
    whiteSpace: 'normal',
  },
  secondary: {
    color: colors.grey[45],
    fontSize: '12px',
    whiteSpace: 'normal',
  },
});

export const useMenuItemStyles = makeStyles({
  gutters: {
    paddingLeft: '0',
    paddingRight: '8px',
  },
  root: {
    borderRadius: '3px',
    margin: '8px 16px 8px 32px',
    '&:hover': {
      backgroundColor: '#F6F6F6',
    },
  },
  selected: {
    '&.Mui-selected': {
      backgroundColor: colors.blue[90],
    },
  },
});

export const useStateHeaderStyles = makeStyles({
  gutters: {
    paddingLeft: '0',
    paddingRight: '8px',
  },
  root: {
    borderRadius: '3px',
    margin: '8px 16px',
    backgroundColor: '#F9FAFB',
    borderBottom: '1px solid #E5E7EB',
    '&:hover': {
      backgroundColor: '#F3F4F6',
    },
  },
});

export const useSearchInputStyles = makeStyles({
  root: {
    width: '100%',
    marginTop: '8px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '4px',
      fontSize: '13px',
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#B6B6B6',
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: '#7FB1F4',
        borderWidth: '1px',
      },
    },
    '& .MuiOutlinedInput-input': {
      padding: '10px 12px',
    },
  },
});
